import React from 'react';
import PropTypes from 'prop-types';
import { WrapperProgress } from './wrapperProgress.jsx';

const LoadingProgress = React.memo((props) => {
  if (!props.active) return null;
  return <WrapperProgress {...props} />;
});

LoadingProgress.propTypes = {
  /**
   *  Value = START  -> start progress run background and FINISH progress 100%
   */
  progress: PropTypes.oneOf(['NONE', 'START', 'FINISH']),
  /**
   *  The loader parent background color.
   */
  background: PropTypes.string,
  /**
   *  Hide entirely the progress spinner
   */
  active: PropTypes.bool,
  /**
   * What className to use
   */
  className: PropTypes.string,
  /**
   * What className to use
   */
  afterFinish: PropTypes.func,
  /**
   * Show only Loading (hide logo , close button )
   */
  index: PropTypes.number,
  /**
   * Time animation background run
   */
  timeBackgroundRun: PropTypes.number,
  /**
   * List message next other message
   */
  messages: PropTypes.array,
  /**
   * Time to next other message
   */
  timeNextMessage: PropTypes.number,
};


LoadingProgress.displayName = "LoadingProgress";
export default LoadingProgress;